var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.getSpinnerOn),expression:"getSpinnerOn"}],staticClass:"blackoutScreen"},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"secondary","size":100,"width":15}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }